export const it = {
  addressPickerComponent: {
    fields: {
      cap: {
        label: "CAP",
        placeholder: "Inserisci CAP",
      },
      province: {
        label: "Seleziona provincia",
        placeholder: "Inserisci provincia",
      },
      city: {
        label: "Città",
        title: "Seleziona città",
      },
      address: {
        label: "Indirizzo e numero civico",
        placeholder: "Via, piazza, cso e numero civico",
      },
    },
    errors: {
      capRequired: "Inserisci CAP valido",
      capMaxLength: "Inserisci massimo 5 numeri",
      capInvalid: "CAP non valido",
      provinceRequired: "Campo obbligatorio",
      cityRequired: "Campo obbligatorio",
      addressRequired: "Inserisci indirizzo valido",
      addressMaxLength: "Numero di caratteri superato",
      addressInvalid:
        "Indirizzo incompleto. Inserisci: via, piazza, vicolo, c.so e numero civico/SNC",
    },
    cta: "Conferma indirizzo",
  },
};
